import styled from 'styled-components';

export const Container = styled.div`
  padding: 32px;
  border-bottom: 1px solid #e2e8f080;
  border-top: 1px solid #e2e8f080;
  box-shadow: 0px 20px 25px -5px #0000001a;
  background-color: white;
  max-width: 1327px;
  margin: 0 auto;

  @media (max-width: 1558px) {
    max-width: 1200px;
    padding: 16px;
  }
  @media (max-width: 1450px) {
    max-width: 1100px;
  }

  @media (max-width: 1090px) {
    max-width: 990px;
    padding: 16px;
  }
  @media (max-width: 991px) {
    padding: 32px;
  }
  @media (max-width: 767px) {
    padding: 32px 16px;
  }
  @media (max-width: 325px) {
    padding: 32px 8px;
  }
`;
export const HeaderTop = styled.div`
  display: flex;
  @media (max-width: 575px) {
    width: fit-content;
  }
`;
export const NewLeadImg = styled.div`
  background: linear-gradient(135deg, #51a2ff 0%, #ad46ff 100%);
  box-shadow: 0px 10px 15px -3px #0000001a;
  padding: 14px;
  display: inline-block;
  border-radius: 16px;
  cursor: pointer;
`;
export const NewLeadIcon = styled.img`
  display: flex;
`;
export const HeaderTitleBlock = styled.div`
  margin-left: 12px;
  @media (max-width: 575px) {
    display: none;
  }
`;
export const HeaderTitle = styled.h2`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0px;
  color: #212529;
`;
export const HeaderSubTitle = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #6c757d;
`;
export const HeaderContent = styled.div`
  margin-top: 32px;
  display: flex;
  gap: 24px;
  @media (max-width: 991px) {
    flex-direction: column;
  }
  @media (max-width: 425px) {
    align-items: center;
  }
`;
export const HeaderStep = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 235px;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    width: 34px;
    height: 4px;
    background: ${(props) => (props.isCompleted ? '#05df72' : '#e2e8f0')};
    border-radius: 16px;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
  }

  @media (max-width: 1558px) {
    min-width: 215px;
  }
  @media (max-width: 1450px) {
    min-width: 185px;
  }
  @media (max-width: 1090px) {
    min-width: 160px;
  }
  @media (max-width: 991px) {
    min-height: 105px;
    align-items: self-start;
    &::after {
      height: 56px;
      width: 4px;
      left: 22px;
      right: auto;
      bottom: -14px;
      top: auto;
      transform: translateY(0);
      background: ${(props) => (props.isCompleted ? '#05df72' : '#e2e8f0')};
    }
  }
  @media (max-width: 575px) {
    min-width: auto;
    width: fit-content;
  }
  @media (max-width: 575px) {
    gap: 8px;
  }
`;
export const StepImg = styled.div`
  width: ${(props) => (props.isCompleted ? '44px' : '48px')};
  height: ${(props) => (props.isCompleted ? '44px' : '48px')};
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
  flex-shrink: 0;
  background: ${(props) => {
    if (props.isCompleted) return '#05df72';
    if (props.isActive) return '#3b82f6';
    return '#f1f5f9';
  }};

  box-shadow: ${(props) => {
    if (props.isCompleted) return '0px 10px 15px -3px rgba(40, 167, 69, 0.3)';
    if (props.isActive) return '0px 10px 15px -3px #3b82f64d';
    return '0px 10px 15px -3px #0000001a';
  }};
`;
export const StepIcon = styled.img`
  display: flex;
  filter: ${(props) =>
    props.isActive || props.isCompleted ? 'brightness(0) invert(1)' : 'none'};
`;
export const StepContent = styled.div`
  @media (max-width: 460px) {
    display: none;
  }
`;
export const StepTitle = styled.h4`
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  color: ${(props) => {
    if (props.isActive || props.isCompleted) return '#0f172b';
    return '#62748e';
  }};
`;
export const StepSubTitle = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #90a1b9;
  @media (max-width: 480px) {
    font-size: 12px;
  }
`;
